import React, { useState } from 'react';
import ViewFilterButton from '../../../../../components/ProTable/ViewFilterButton';
import { useSelector } from 'react-redux';
import { getFilter } from '../../../../../stores/algos-list/getters';
import { updateFilter } from '../../../../../stores/algos-list/actions';
import ViewFilterModalDecorated from '../../../../../components/ProTable/ViewFilterModalDecorated';

const options = [
  {
    label: 'Buy',
    value: 'B',
  },
  {
    label: 'Sell',
    value: 'S',
  },
  {
    label: 'Buy/Sell',
    value: 'B/S',
  },
];

const ViewTransactionType = () => {
  const [open, setOpen] = useState(false);
  const viewsFilter = useSelector((state) => {
    const { views = {} } = getFilter(state);
    return views;
  });
  const isViewActive = viewsFilter.transactionType ? true : false;

  function onOpen() {
    setOpen(true);
  }

  function onClose() {
    setOpen(false);
  }

  return (
    <>
      <ViewFilterButton onClick={onOpen} isActive={isViewActive} />
      {open ? (
        <ViewFilterModalDecorated
          open={open}
          onClose={onClose}
          updateFilter={updateFilter}
          options={options}
          viewsFilter={viewsFilter}
          fieldName="transactionType"
          title="Filter Buy/Sell:"
        />
      ) : (
        ''
      )}
    </>
  );
};

export default ViewTransactionType;
